import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { completeStripeSetupSession } from "api/Accounts/AccountsAPI";
import Container from "@mui/material/Container/Container";


export default function RegisterPaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function complete() {
      try {
        const sessionId = searchParams.get("session_id");
        if (!sessionId) {
          setError("Missing session ID.");
          return;
        }

        await completeStripeSetupSession(sessionId);
        navigate("/community/");
      } catch (err: any) {
        console.error(err);
        setError(
          err.response?.data?.error ||
            "Could not verify payment method setup."
        );
      }
    }

    complete();
  }, [navigate, searchParams]);

  if (error) {
    return(
      <Container>
        <h2>Error: {error}</h2>
      </Container>
    );
  }

  return(
    <Container>
      <h2>Finalising your account...</h2>
    </Container>
  )
}